import { render, staticRenderFns } from "./FilterButton.vue?vue&type=template&id=a8630b0c&scoped=true&"
import script from "./FilterButton.vue?vue&type=script&lang=ts&"
export * from "./FilterButton.vue?vue&type=script&lang=ts&"
import style0 from "./FilterButton.vue?vue&type=style&index=0&id=a8630b0c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8630b0c",
  null
  
)

export default component.exports